export default __webpack_public_path__ + "static/media/cheap.8baa5561.svg";